// extracted by mini-css-extract-plugin
export default {"footer":"RNABr3-Yu0qxkxnL93ELXw==","color":"nHgp-XORAUnWO-GWabIkxw==","cardBody":"hMUCzscHiMuywdB1OSrQVQ=="};